import { render, staticRenderFns } from "./ProjectTeamPermissions.vue?vue&type=template&id=d954bcca&scoped=true"
import script from "./ProjectTeamPermissions.vue?vue&type=script&lang=js"
export * from "./ProjectTeamPermissions.vue?vue&type=script&lang=js"
import style0 from "./ProjectTeamPermissions.vue?vue&type=style&index=0&id=d954bcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d954bcca",
  null
  
)

export default component.exports